import cloneDeep from 'lodash/cloneDeep';

export interface Permission {
  permission: string;
  description: string;
  key: string;
}

export const sortPermissionsInPermissionGroups = (permissionGroups) => {
  const permissionGroupsClone = cloneDeep(permissionGroups);
  Array.from(permissionGroupsClone.keys()).forEach((pGroup) => {
    const originalArray = permissionGroupsClone.get(pGroup);
    const permissions = sortPermissionsArray(originalArray);
    permissionGroupsClone.set(pGroup, permissions);
  });
  return permissionGroupsClone;
};

export const sortPermissionsArray = (permissionsArray: Permission[]) => {
  const customOrder = ['READ', 'WRITE', 'CONFIGURE', 'DELETE'];
  const permissions = cloneDeep(permissionsArray);
  permissions?.sort((permission1, permission2) => {
    const indexA = customOrder.indexOf(permission1?.key?.split('_')?.pop());
    const indexB = customOrder.indexOf(permission2?.key?.split('_')?.pop());
    if (indexA !== -1 && indexB !== -1) {
      return indexA - indexB;
    } else if (indexA !== -1) {
      return -1;
    } else if (indexB !== -1) {
      return 1;
    }
  });
  return permissions;
};
